function resizeGridItem(item){
    let grid = document.getElementsByClassName("grid")[0];
    let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
    let rowSpan = Math.ceil((item.querySelector('.content__grid').getBoundingClientRect().height+rowGap) / (rowHeight+rowGap));
    item.style.gridRowEnd = "span "+rowSpan;
}

function resizeAllGridItems(){
    let allItems = document.getElementsByClassName("item__grid");
    let x
    for(x=0;x<allItems.length;x++){
        resizeGridItem(allItems[x]);
    }
}

function resizeInstance(instance){
    let item = instance.elements[0];
    resizeGridItem(item);
}

window.onload = resizeAllGridItems();
window.addEventListener("resize", resizeAllGridItems);

let allItems = document.getElementsByClassName("item__grid");
let x
for(x=0;x<allItems.length;x++){
    var imagesLoaded
    imagesLoaded( allItems[x], resizeInstance);
}


// WEBPACK FOOTER //
// ./src/js/grid__vocabulary.js